import * as React from "react";
import Svg, { Path } from "react-native-svg";

function ArrowRight(props) {
  return (
    <Svg width={22} height={12} viewBox="0 0 22 12" fill="none" {...props}>
      <Path
        d="M0.826441 4.79125C0.882704 4.78238 0.939642 4.77829 0.996611 4.77901H18.947L18.7354 4.68341C18.5287 4.58832 18.3406 4.45891 18.1796 4.30103L15.4594 1.65779C15.1011 1.32548 15.0409 0.790887 15.3167 0.391146C15.6377 -0.0348241 16.2533 -0.127313 16.6917 0.184599C16.7271 0.209812 16.7608 0.237296 16.7924 0.266871L21.7115 5.04668C22.0959 5.4198 22.0962 6.02507 21.7122 6.39861L21.7115 6.39936L16.7924 11.1792C16.4077 11.552 15.7848 11.5511 15.4011 11.1773C15.3709 11.1479 15.3427 11.1165 15.3167 11.0836C15.0409 10.6838 15.1011 10.1492 15.4594 9.81692L18.1747 7.16891C18.319 7.0285 18.485 6.91077 18.6666 6.81998L18.9617 6.69093H1.05075C0.54818 6.70906 0.107248 6.36793 0.0128345 5.88792C-0.0741405 5.36677 0.290113 4.8758 0.826441 4.79125Z"
        fill="white"
      />
    </Svg>
  );
}

export default ArrowRight;
